import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import Home from './Component/Home/index';

function App() {
  return (
    <>
      <div className="container-fluid">
        <Home />
      </div>
    </>
  );
}

export default App;
